var getDefaultStyleSheet = _ref => {
  var {
    colorToken,
    colorTokenArgs,
    designContext
  } = _ref;
  var borderColor = designContext.get(colorToken ? colorToken : 'separator/border-color', colorToken ? colorTokenArgs : undefined).toString();
  return {
    rootStyle: {
      borderTopWidth: 1,
      borderTopColor: borderColor,
      width: '100%'
    }
  };
};
export { getDefaultStyleSheet };
//# sourceMappingURL=getDefaultStyleSheet.js.map